import { Col } from "react-bootstrap";
import LinkIcon from '@mui/icons-material/Link';
<script src="https://unpkg.com/boxicons@2.1.4/dist/boxicons.js"></script>


export const ProjectCard = ({ title, description, imgUrl,hostlink }) => {
  
  
  return (
    <Col size={12} sm={6} md={4}>
      <div className="proj-imgbx">
        <img src={imgUrl} />
        <div className="proj-txtx">
          <h4>{title}</h4>
          <span>{description}</span>
          <p><i class='bx bx-link-alt'>
              <a href={hostlink}>
                  <LinkIcon />
                </a>
          </i></p>

        </div>
      </div>
    </Col>
  )
}